
export class FileURL {

  public fileURL: string;


}



// WEBPACK FOOTER //
// ./src/app/models/FileURL.model.ts